import React, { useEffect, useState } from 'react'
import { useTranslation } from '../hook/useTranslation'
import {waitForGet} from "../utils/api";

const HealthCheck = ({api})=>{

    const i18n = useTranslation("healthCheck")
    const {
        websocket_connected = "✅ Is connected to service",
        websocket_not_connected =  "🚨 Is not connected to service",
        get_events = "✅ %s events counted",
        no_events =  "🚨 Could not fetch data"
    } = i18n

    const [socketIsConnected, setSocketIsConnected] = useState(false);
    const [eventsCount, setEventsCount] = useState(0);
    const [retrySocketConnection, setRetrySocketConnection] = useState(0);

    useEffect(()=>{
        let isMounted = true;
        let retryTimeout = null;
        waitForGet(api,async (get)=>{
            try{
                const socket = await get.socket;
                setSocketIsConnected(socket.connected);
            } catch (e) {
                setSocketIsConnected(false);
                retryTimeout = setTimeout(()=>{
                    if(isMounted) setRetrySocketConnection(retrySocketConnection+1);
                }, 1000);
            }
        });
        return ()=>{
            isMounted = false;
            clearTimeout(retryTimeout);
        }
    }, [])

    useEffect(()=>{
        waitForGet(api, async (get)=>{
            try{
                const result = await get.query({
                    fields: [
                        {
                            field: 'hits',
                            operations: [
                                'sum',
                            ],
                            as: 'count',
                        },
                    ],
                });
                if(result.error){
                    setEventsCount(-1)
                } else {
                    setEventsCount(result.value[0].count)
                }
            } catch (e) {
                setEventsCount(-1);
            }
        });
    }, []);

    const socketText = socketIsConnected ? websocket_connected: websocket_not_connected
    const eventsCountText = eventsCount >= 0 ? get_events.replace('%s', eventsCount): no_events

    return <div>
        <p>{socketText}</p>
        <p>{eventsCountText}</p>
    </div>
}

export default HealthCheck